module.exports = require('./helpers/bundle-url').getBundleURL('ldGXu') + require('./helpers/bundle-manifest').resolve("dEJUC");